import { z, ZodType } from 'zod';

const M_TO_FT = 3.28084;

export const HeightUnitsWithoutKM = ['M', 'FT'] as const;
export const HeightUnitWithoutKMZod = z.enum(HeightUnitsWithoutKM);
export type HeightUnitWithoutKM = z.infer<typeof HeightUnitWithoutKMZod>;

export const HeightUnits = ['KM', 'M', 'FT'] as const;
export const HeightUnitZod = z.enum(HeightUnits);
export type HeightUnit = z.infer<typeof HeightUnitZod>;

export const HeightZod = z.object({
  value: z.number().int(),
  unit: HeightUnitZod,
});
export type Height = z.infer<typeof HeightZod>;

export const HeightUnitText: Record<HeightUnit, string> = {
  M: 'm',
  FT: 'ft',
  KM: 'km',
};

export const HeightUnitIwxxmText: Record<HeightUnit, string> = {
  M: 'M',
  FT: 'FT',
  KM: 'KM',
};

export const HeightUnitTacText: Record<HeightUnit, string> = {
  M: 'M',
  FT: 'FT',
  KM: 'KM',
};

export const HeightFromTypes = ['GND', 'MSL'] as const;
export const HeightFromTypeZod = z.enum(HeightFromTypes);
export type HeightFromType = z.infer<typeof HeightFromTypeZod>;

export const HeightFromZod = HeightZod.extend({
  from: HeightFromTypeZod,
});
export type HeightFrom = z.infer<typeof HeightFromZod>;

export const HeightFromTypeText: Record<HeightFromType, string> = {
  GND: 'Source',
  MSL: 'MSL',
};

export const HeightFromTypeIwxxmText: Record<HeightFromType, string> = {
  GND: 'SFC',
  MSL: 'MSL',
};

export const HeightFromTypeTacText: Record<HeightFromType, string> = {
  GND: 'ABV SOURCE',
  MSL: 'AMSL',
};

export const limitHeightZod = <T extends Height>(
  heightZod: ZodType<T>,
  minMetres: number,
  maxMetres: number,
) => {
  return heightZod.superRefine((val, ctx) => {
    if (val.unit === 'M' && (val.value < minMetres || val.value > maxMetres)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['value'],
        message: `Height must be between ${minMetres} and ${maxMetres} metres.`,
      });
    } else if (val.unit === 'FT') {
      const minFeet = Math.round(minMetres * M_TO_FT);
      const maxFeet = Math.round(maxMetres * M_TO_FT);
      if (val.value < minFeet || val.value > maxFeet) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['value'],
          message: `Height must be between ${minFeet} and ${maxFeet} feet.`,
        });
      }
    }
  });
};
